import { LogLevel, CacheLookupPolicy, InteractionRequiredAuthError } from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
import { accentUtils, getLoginParameters, reloading, clearReloading } from "../services/HelperService";
import { update } from "../services/DataService";


let acquireTokenPromise = null;


////function handleResponsePromise(instance) {


////    instance.handleRedirectPromise().then((response) => {
////        // You can check the response here and handle login or token acquisition
////        if (response !== null) {
////            console.log("Response from redirect:", response);
////        }
////    }).catch((error) => {
////        console.error(error);
////    });

////}

  
const logLevel =
    {
        Error: LogLevel.Error,
        Warning: LogLevel.Warning,
        Info: LogLevel.Info,
        Verbose: LogLevel.Verbose,
        Trace: LogLevel.Trace,
    }[process.env.REACT_APP_MSAL_LOG_LEVEL] ?? LogLevel.Info;

export class AuthorizeService {


    constructor() {

        this.b2cPolicies = null;
        this.msalConfig = null;
        this.msalInstance = null;
        this.defaultScope = null;

        this.impersonateConfig = null;
        this.impersonateInstance = null;

        this.signupConfig = null;
        this.signupInstance = null;

        this.Initialize = this.Initialize.bind(this);
        this._acquireToken = this._acquireToken.bind(this);

    }





    async Initialize() {

        try {


            const response = await fetch(`api/AuthSettings/ClientConfig`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                const message = `An error has occured: ${response.status}`;

                const text = await response.text();

                throw new Error(message);
            }


            var config = await response.json();

            const domainName = config.Domain.split(".")[0];

            this.defaultScope = {
                scopes: [config.DefaultScope, 'openid']
            };

            this.b2cPolicies = {
                names: {
                    signIn: config.SignInPolicyId,
                    signUpSignIn: config.SignUpSignInPolicyId,
                    impersonate: config.ImpersonatePolicyId,
                    forgotPassword: config.ResetPasswordPolicyId,
                    editProfile: config.EditProfilePolicyId
                },
                authorities: {
                    signIn: {
                        authority: `https://${domainName}.b2clogin.com/${config.Domain}/${config.SignInPolicyId}`,
                    },
                    forgotPassword: {
                        authority: `https://${domainName}.b2clogin.com/${config.Domain}/${config.ResetPasswordPolicyId}`,
                    },
                    editProfile: {
                        authority: `https://${domainName}.b2clogin.com/${config.Domain}/${config.EditProfilePolicyId}`
                    },
                    signUpSignIn: {
                        authority: `https://${domainName}.b2clogin.com/${config.Domain}/${config.SignUpSignInPolicyId}`,
                    },
                    impersonate: {
                        authority: `https://${domainName}.b2clogin.com/${config.Domain}/${config.ImpersonationPolicyId}`,
                    }
                },
                authorityDomain: `${domainName}.b2clogin.com`
            }


            this.msalConfig = {
                auth: {
                    clientId: config.ClientId, // This is the ONLY mandatory field that you need to supply.
                    authority: this.b2cPolicies.authorities.signIn.authority, // Choose SUSI as your default authority.
                    knownAuthorities: [this.b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
                    redirectUri: config.CallbackPath, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
                    postLogoutRedirectUri: "/logout", // Indicates the page to navigate after logout.
                    navigateToLoginRequestUrl: true // If "true", will navigate back to the original request location before processing the auth code response.

                },
                cache: {
                    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
                    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
                },
                system: {
                    loggerOptions: {
                        logLevel,
                        loggerCallback: (level, message, containsPii) => {
                            if (containsPii) {
                                return;
                            }
                            switch (level) {
                                case LogLevel.Error:
                                    console.error(message);
                                    return;
                                case LogLevel.Info:
                                    console.info(message);
                                    return;
                                case LogLevel.Verbose:
                                    console.debug(message);
                                    return;
                                case LogLevel.Warning:
                                    console.warn(message);
                                    return;
                            }
                        }
                    },
                    windowHashTimeout: 3600000,
                    iframeHashTimeout: 10000,
                    loadFrameTimeout: 0,
                },
            };


            this.msalInstance = new PublicClientApplication(this.msalConfig);

            var p = await this.msalInstance.initialize();


            this.impersonateConfig = {
                auth: {
                    clientId: config.ClientId, // This is the ONLY mandatory field that you need to supply.
                    authority: this.b2cPolicies.authorities.impersonate.authority, // Choose SUSI as your default authority.
                    knownAuthorities: [this.b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
                    redirectUri: config.CallbackPath, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
                    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
                    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.

                },
                cache: {
                    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
                    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
                },
                system: {
                    loggerOptions: {
                        logLevel,
                        loggerCallback: (level, message, containsPii) => {
                            if (containsPii) {
                                return;
                            }
                            switch (level) {
                                case LogLevel.Error:
                                    console.error(message);
                                    return;
                                case LogLevel.Info:
                                    console.info(message);
                                    return;
                                case LogLevel.Verbose:
                                    console.debug(message);
                                    return;
                                case LogLevel.Warning:
                                    console.warn(message);
                                    return;
                            }
                        }
                    }
                }

            };
            this.impersonateInstance = new PublicClientApplication(this.impersonateConfig);

            await this.impersonateInstance.initialize();

            this.signupConfig = {
                auth: {
                    clientId: config.ClientId, // This is the ONLY mandatory field that you need to supply.
                    authority: this.b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
                    knownAuthorities: [this.b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
                    redirectUri: config.SignupCallbackPath, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
                    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
                    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.

                },
                cache: {
                    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
                    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
                },
                system: {
                    loggerOptions: {
                        logLevel,
                        loggerCallback: (level, message, containsPii) => {
                            if (containsPii) {
                                return;
                            }
                            switch (level) {
                                case LogLevel.Error:
                                    console.error(message);
                                    return;
                                case LogLevel.Info:
                                    console.info(message);
                                    return;
                                case LogLevel.Verbose:
                                    console.debug(message);
                                    return;
                                case LogLevel.Warning:
                                    console.warn(message);
                                    return;
                            }
                        }
                    }
                }

            };
            this.signupInstance = new PublicClientApplication(this.signupConfig);
            await this.signupInstance.initialize();

            window.imageBaseURL = config.BaseImageURL;
            window.productImageBaseURL = config.BaseProductImageURL;
            window.msalInstance = this.msalinstance;
            if (this.isSignUp()) {

                this.removeAllAccounts();
            }

            return this.getInstance();

        } catch (e) {
            console.log(e);
        }
    }

    getConfig() {
        const urlParams = new URLSearchParams(window.location.search);
        const impersonateParam = urlParams.get('impersonate');
        const linkParam = urlParams.get('linkUser');
        if (impersonateParam != null) {
            return this.impersonateConfig;
        }
        if (linkParam != null) {
            return this.signupConfig;
        }


        return this.msalConfig;
    }

    isImpersonation() {
        const urlParams = new URLSearchParams(window.location.search);
        const impersonateParam = urlParams.get('impersonate');
        if (impersonateParam != null) {
            return true;
        }
        return false;
    }

    isSignUp() {
        const urlParams = new URLSearchParams(window.location.search);
        const impersonateParam = urlParams.get('linkUser');
        if (impersonateParam != null) {
            return true;
        }
        return false;
    }
    getInstance() {
        const urlParams = new URLSearchParams(window.location.search);
        const impersonateParam = urlParams.get('impersonate');
        const linkParam = urlParams.get('linkUser');
        if (impersonateParam != null) {
            return this.impersonateInstance;
        }
        if (linkParam != null) {
            return this.signupInstance;
        }

        return this.msalInstance;
    }

    getLoginRequest() {
        const urlParams = new URLSearchParams(window.location.search);
        const linkParam = urlParams.get('linkUser');

        const stateParam = urlParams.get('state');
        if (linkParam) {
            return {
                scopes: this.defaultScope.scopes, extraQueryParameters: getLoginParameters(), state: stateParam
            };
        } else {
            return {
                scopes: this.defaultScope.scopes, extraQueryParameters: getLoginParameters()
            };
        }

    }
    signIn() {

        this.getInstance().loginRedirect(this.getLoginRequest());
    }


    signOut() {
        this.msalInstance.logoutRedirect();
        //this.logoutAllAccounts();
    }

    signOutWithRedirect(redirecturi) {

        const inst = this.getInstance();

        if (inst) {
            inst.logoutRedirect({
                postLogoutRedirectUri: redirecturi
            }).catch(e => {

                if (e.errorCode === "interaction_in_progress") {
                    this.logoutAllAccounts(true);
                }

                const dd = e;
            });
        }

            
    }

    signOutAuthFailed() {
        var me = this;
        if (this.msalInstance) {
            this.msalInstance.handleRedirectPromise().then(r => { me.msalInstance.logoutRedirect() });
        }
    }
    async resetPassword() {
        const instance = this.getInstance();
        instance.loginRedirect(this.b2cPolicies.authorities.forgotPassword);

    }

    async isSignIn() {
        const instance = this.getInstance();
        var accounts = instance.getAllAccounts();
        var account = accounts[0];
        var signinPolicy = this.msalConfig.auth.authority.split("/").pop().toLowerCase()
        if (account) {
            if (account.homeAccountId.toLowerCase().includes(signinPolicy)) {
                return true;
            }
        }
        return false;
    }

    async completeSignin() {
        const instance = this.msalInstance;
        await instance.handleRedirectPromise().then(r => {


            const tt = r;


        }).catch(e => {

            const tt = e;
        });

    }

    async completeSignup() {
        const instance = this.signupInstance;


        try {
            await instance.handleRedirectPromise();
        } catch (e) {

            this.signOut();

        }
        
        const instancePolicy = this.signupConfig.auth.authority.split("/").pop().toLowerCase();
        var accounts = instance.getAllAccounts().filter(item => item.homeAccountId.toLowerCase().includes(instancePolicy));
        if (accounts.length == 0) {
            accounts = instance.getAllAccounts();
        }
        var account = accounts[0];
        const t = await instance.acquireTokenSilent({
            account: account,
            ...this.defaultScope,
            cacheLookupPolicy: 2

        });
        if (!accentUtils.isNull(t)) {
            //should be linking, we came from signup
            const stateParam = t.account.idTokenClaims.redirectState;
            if (!accentUtils.isNull(stateParam)) {
                var splitState = stateParam.split(/_(.*)/s);
                if (splitState.length > 1) {
                    var clientId = splitState[0];
                    var email = splitState[1].replace(" ","+");
                    if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(clientId)) {
                        var args = { BusinessClaim: clientId, UserName: email, UserID: t.account.idTokenClaims.sub };
                        const response = await fetch(`api/Update/LinkUserToBusiness`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                ...(!t.accessToken ? {} : { 'Authorization': `Bearer ${t.accessToken}` })
                            },
                            body: JSON.stringify(args)
                        });
                    }
                }
            }
            
        }
    }


    

    async _acquireToken(msalInstance, request, allowReLogin) {
        if (acquireTokenPromise) {
            return acquireTokenPromise;
        }

        acquireTokenPromise = new Promise(async (resolve, reject) => {
            try {
                const response = await msalInstance.acquireTokenSilent(request);
                resolve(response.accessToken);
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    try {

                        if (!allowReLogin) {
                            resolve(null);
                            return;
                        }

                        const response = await msalInstance.acquireTokenPopup(request);
                        resolve(response.accessToken);
                    } catch (popupError) {
                        reject(popupError);
                        this.signOut();
                    }
                } else if (error.errorCode === "no_account_error") {
                    const response = await msalInstance.acquireTokenPopup(request);
                    resolve(response.accessToken);

                } else {
                    reject(error);
                    this.signOut();
                }
            } finally {
                acquireTokenPromise = null;
            }
        });

        return acquireTokenPromise;
    }

    async getAccessToken(allowReLogin = true) {
        if (this.msalInstance) {

            const instance = this.getInstance();
            const instancePolicy = this.getConfig().auth.authority.split("/").pop().toLowerCase();
            var accounts = instance.getAllAccounts().filter(item => item.homeAccountId.toLowerCase().includes(instancePolicy));
            if (accounts.length == 0) {
                accounts = instance.getAllAccounts();
                if (this.isImpersonation()) {
                    instance.loginRedirect(this.getLoginRequest());
                }
            }

            const account = accounts.length > 0 ? accounts.reduce((prev, current) => (prev.idTokenClaims.auth_time > current.idTokenClaims.auth_time) ? prev : current) : null;

            const request = {
                account: account,
                ...this.defaultScope,
                cacheLookupPolicy: 2

            };


            return await this._acquireToken(instance, request, allowReLogin);

        }

        return null;

    }

    async loginPopup() {
        if (this.msalInstance) {

            const instance = this.getInstance();
            const instancePolicy = this.getConfig().auth.authority.split("/").pop().toLowerCase();
            var accounts = instance.getAllAccounts().filter(item => item.homeAccountId.toLowerCase().includes(instancePolicy));
            if (accounts.length == 0) {
                accounts = instance.getAllAccounts();
                if (this.isImpersonation()) {
                    instance.loginRedirect(this.getLoginRequest());
                }
            }

            const account = accounts.length > 0 ? accounts.reduce((prev, current) => (prev.idTokenClaims.auth_time > current.idTokenClaims.auth_time) ? prev : current) : null;

            const request = {
                account: account,
                ...this.defaultScope,
                cacheLookupPolicy: 2

            };


            await instance.loginPopup(request);

        }

        

    }

   
    async removeAllAccounts() {
        this.msalInstance.getTokenCache().storage.removeAllAccounts();
    }

    async logoutAllAccounts(clearReturnUrl) {
        const instance = this.getInstance();
        const instancePolicy = this.getConfig().auth.authority.split("/").pop().toLowerCase();
        var accounts = instance.getAllAccounts().filter(item => item.homeAccountId.toLowerCase().includes(instancePolicy));
        if (accounts.length == 0) {
            accounts = instance.getAllAccounts();
        }
        await instance.getTokenCache().storage.removeAllAccounts();


        if (clearReturnUrl) {
            window.location.href = '/logout';
        } else {
            window.location.href = '/logout?returnUrl=' + window.location.pathname+window.location.search;
        }
        
        //this.msalInstance.loginRedirect(this.getLoginRequest());
    }

    async isAuthenticated() {

        const accessToken = await this.getAccessToken(false);

        return !accentUtils.isEmpty(accessToken);
    }

   

}

const authService = new AuthorizeService();

export default authService;

